import { FocusNode } from '@please/lrud'
import styled, { css } from 'styled-components'

export const LineGroupElem = styled(FocusNode)<{
  $isNested?: boolean
  defaultFocusChild: number
  $totalLines: number
}>`
  ${({ $isNested, defaultFocusChild, $totalLines }) => {
    const UP = 4
    const DOWN = 4

    const startIndex = Math.max(defaultFocusChild - UP, 0)
    const endIndex = Math.min(defaultFocusChild + DOWN, $totalLines - 1)

    const arr = Array.from(
      { length: endIndex - startIndex + 1 },
      (_, i) => startIndex + i + 1,
    )

    return css`
      > div ${!$isNested ? `> div` : ''} {
        .slider__item {
          display: none;
        }
        .slider__item.empty__item {
          display: flex;
        }

        ${arr.map(
          (item) => css`
            &:nth-child(${item}) .slider__item {
              display: flex;
            }
          `,
        )}
      }
    `
  }}
`

export const LineLoaderElem = styled(FocusNode)`
  min-height: 216px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 112px;
`

export const LineLoaderWrapper = styled(FocusNode)`
  position: relative;
`
